import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { fetchQuery, graphql } from "react-relay";
import { environment } from "@/relay/environment";
import type { routeAdminClubQuery } from "./__generated__/routeAdminClubQuery.graphql";

export const Route = createFileRoute("/_logged/c/$club")({
	component: RouteComponent,
	beforeLoad: async ({ params: { club: clubSlug } }) => {
		const data = await fetchQuery<routeAdminClubQuery>(
			environment,
			graphql`
        query routeAdminClubQuery($slug: String!) {
          user {
            clubs {
              id
              slug
              name
              logo {
                signedUrl
              }
            }
          }
          club(slug: $slug) {
            id
            name
            slug
            permissions {
              slug
            }
            logo {
              signedUrl
            }
            themes {
              styles
            }
            domains {
              enabled
              domain
            }
          }
        }
      `,
			{ slug: clubSlug },
		).toPromise();

		if (!data?.club) {
			throw notFound();
		}

		return { club: data.club, clubs: data.user?.clubs ?? [] };
	},
});

function RouteComponent() {
	return <Outlet />;
}
